import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const XataIOIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 450 450"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <linearGradient
        id="paint0_linear_48_446"
        x1={-0.03}
        x2={-0.03}
        y1={0}
        y2={1.01}
      >
        <stop stopColor="currentColor" />
        <stop offset={1} stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_48_446"
        x1={1.03}
        x2={1.03}
        y1={0}
        y2={1.01}
      >
        <stop stopColor="currentColor" />
        <stop offset={1} stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_48_446"
        x1={-0.51}
        x2={-0.51}
        y1={-0.02}
        y2={1}
      >
        <stop stopColor="currentColor" />
        <stop offset={1} stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_48_446"
        x1={1.51}
        x2={1.51}
        y1={-0.02}
        y2={1}
      >
        <stop stopColor="currentColor" />
        <stop offset={1} stopColor="currentColor" />
      </linearGradient>
    </defs>
    <path
      d="m413.95,134.96c-0.05,37.77 -14.92,73.98 -41.36,100.65l0,0l-93.79,94.64c-3.25,3.28 -8.53,3.29 -11.57,-0.19c-22.81,-26.02 -35.48,-59.67 -35.44,-94.63c0.05,-37.77 14.92,-73.98 41.36,-100.66l0,0.01l85.69,-86.47c7.72,-7.79 20.36,-7.85 26.91,0.98c18.23,24.56 28.23,54.6 28.2,85.67z"
      fill="url(#paint0_linear_48_446)"
    />
    <path
      d="m78.41,236.19c-26.43,-26.68 -41.31,-62.89 -41.35,-100.66c-0.04,-31.07 9.96,-61.1 28.19,-85.67c6.55,-8.82 19.19,-8.76 26.91,-0.97l85.69,86.46l0,0c26.44,26.68 41.32,62.89 41.36,100.66c0.04,34.96 -12.63,68.61 -35.43,94.63c-3.05,3.47 -8.33,3.47 -11.58,0.19l-93.78,-94.64l-0.01,0z"
      fill="url(#paint1_linear_48_446)"
    />
    <path
      d="m369.06,405.53c-6.89,8.56 -19.49,8.48 -27.2,0.67l-52.92,-53.65c-3.25,-3.3 -3.24,-8.63 0.01,-11.92l87.9,-88.7c3.25,-3.28 8.55,-3.3 11.42,0.33c15.26,19.3 21.26,45.98 16.72,75.36c-4.15,26.88 -16.85,54.21 -35.93,77.91z"
      fill="url(#paint2_linear_48_446)"
    />
    <path
      d="m109.14,406.78c-7.7,7.81 -20.3,7.89 -27.2,-0.67c-19.07,-23.7 -31.77,-51.03 -35.92,-77.92c-4.54,-29.37 1.46,-56.05 16.72,-75.36c2.86,-3.62 8.16,-3.6 11.41,-0.32l87.91,88.7c3.25,3.28 3.26,8.62 0.01,11.91l-52.93,53.66z"
      fill="url(#paint3_linear_48_446)"
    />
  </svg>
)
const ForwardRef = forwardRef(XataIOIcon)
export { ForwardRef as ReactComponent }
